module.exports = __webpack_public_path__ + "static/media/C1.3ba3b54c.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/C1.png
// module id = 891
// module chunks = 0